export default {
    isLogged: () => {
        return localStorage.getItem("currentUser");
    }
};